import React from 'react'
import styled from 'styled-components'

export default () => {
    return <Container>no results</Container>
}

const Container = styled.div`
    width: 100%;
    text-align: center;
`
